<template>
  <div id='id' class="item-width-min">
    <div class='actions-table flex'>
      <button v-can:edit-exploitation class='primary-action mr-5 flex-14 has-tooltip'
              type='button'
              @click='showPriority = true'
              v-tooltip="{ content : getTooltipMessage('priorisation') }"
              :disabled="ilot.non_irrigue"><span>Gérer les priorités</span></button>
      <div class="item-flex-full" />
      <button v-can:edit-exploitation class='primary-action mr-5 flex-14 btn-icon enregistrer'
              type='button'
              @click='save'>Enregistrer</button>
      <button v-can:edit-exploitation class='primary-action mr-5 flex-14 has-tooltip'
              type='button'
              v-tooltip="{ content : getTooltipMessage('add_scenario') }"
              @click='addScenario'><span>Ajouter un scénario</span></button>
    </div>

    <div class="sub_zone">
      <span>{{ ilot.nom }}</span>
      <v-module v-for='sol in sols'
                :title='`${sol.nom} (${sol.surface} ha)`'
                :key='sol.id_ref_type_sol'>
        <input :value='sol.surface'
              :ref='`sau-${sol.id_ref_type_sol}`'
              type='hidden' >
        <table class='max-100 cursor-default border-simulation ilot-simulation' :class="scenarios.length > 3 ? 'scrollbar' : ''">
          <thead>
            <tr>
              <th class="largeur-min culture-name">Culture</th>
              <th v-for='scenario in scenarios'
                  :key='scenario.id_scenario'
                  class='col-number scenario actions-ct has-tooltip largeur-min'>
                  <span class="item-width-max word-break" style="text-align: center" v-tooltip="{ content : getTooltipMessage('scenario') }">{{ scenario.nom }}</span>
                  <v-popover class="action-icon acion-smulation">
                    <!-- This will be the popover target (for the events and position) -->
                    <button class="action-icon">...</button>
                    <!-- This will be the content of the popover -->
                    <div slot="popover" class="">
                      <ul class="actions">
                        <li class="action" @click="doDuplicateScenario(scenario.id_scenario, scenario.nom)">Dupliquer</li>
                        <li class="action" @click="doRenameScenario(scenario.id_scenario, scenario.nom)">Renommer</li>
                        <li class="action" @click="doRemoveScenario(scenario.id_scenario)">Supprimer</li>
                      </ul>
                    </div>
                  </v-popover>
                <v-error-ct :error='errors.first("somme_par_scenario", `somme-${sol.id_ref_type_sol}-${scenario.id_scenario}`)'>
                  <input v-validate='{ confirmed:`sau-${sol.id_ref_type_sol}` }'
                        :value='getSommeSurface(sol.id_ref_type_sol, scenario.id_scenario)'
                        :data-vv-scope='`somme-${sol.id_ref_type_sol}-${scenario.id_scenario}`'
                        type='hidden'
                        name='somme_par_scenario'
                        data-vv-as='somme surface' >
                  <span v-if='(sol.surface - getSommeSurface(sol.id_ref_type_sol, scenario.id_scenario)) > 0'
                        class='information'>Reste à saisir {{ sol.surface - getSommeSurface(sol.id_ref_type_sol, scenario.id_scenario) | formatNumeric}} ha</span>
                  <span v-else-if='(sol.surface - getSommeSurface(sol.id_ref_type_sol, scenario.id_scenario)) < 0'
                        class='information'>Surface dépassée de {{ getSommeSurface(sol.id_ref_type_sol, scenario.id_scenario) - sol.surface | formatNumeric}} ha</span>
                </v-error-ct>
                <div class="sous-information">Surface <span v-show="!ilot.non_irrigue">/ Dose</span></div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for='culture in cultures' :key='culture.id_culture'>
              <td class="largeur-min culture-name">
                <div :class="addClassIfNoData(sol.id_ref_type_sol, culture.id_culture)">
                  <span class='culture'>{{ culture.nom }}</span><span v-if='culture.complement'> - </span><span class='complement'>{{ culture.complement | truncateChars(30) }}</span>
                </div>
              </td>
              <td class="largeur-min" v-for='scenario in scenarios' :key='scenario.id_scenario + "-" + culture.id_culture'>
                <div class="ct-flex-row">
                  <span class="indicateur">{{ getOrderValue(sol.id_ref_type_sol, culture.id_culture, scenario.id_scenario) }}</span>
                  <v-field-float v-validate.initial='"min_value:0|decimal:1"'
                                :value='getCellValueSurface(sol.id_ref_type_sol, culture.id_culture, scenario.id_scenario)'
                                :name='`surface-${sol.id_ref_type_sol}-${culture.id_culture}-${scenario.id_scenario}`'
                                :key='`surface-${sol.id_ref_type_sol}-${culture.id_culture}-${scenario.id_scenario}`'
                                data-vv-as='surface'
                                @input='(value) => updateCellValueSurface(sol.id_ref_type_sol, culture.id_culture, scenario.id_scenario, value)'
                                class="mr-5"/>
                  <v-field-integer v-validate.initial=''
                                :value='getCellValueDose(sol.id_ref_type_sol, culture.id_culture, scenario.id_scenario)'
                                :name='`dose-${sol.id_ref_type_sol}-${culture.id_culture}-${scenario.id_scenario}`'
                                :key='`dose-${sol.id_ref_type_sol}-${culture.id_culture}-${scenario.id_scenario}`'
                                v-show="!ilot.non_irrigue"
                                data-vv-as='dose'
                                @input='(value) => updateCellValueDose(sol.id_ref_type_sol, culture.id_culture, scenario.id_scenario, value)'
                                placeholder="dose"
                                class="mr-5"/>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </v-module>
    </div>
    <Priorite :show="showPriority"
      :cultures="cultures"
      :scenarios="scenarios"
      :sols="sols"
      :parcelles="parcelles"
      @cancel="showPriority = false"
      @validate="onValidatePriority"/>
  </div>
</template>

<script>
import Priorite from '@/components/Priorite'
import mixinConfirmation from '@/mixins/confirmation'
import mixinCheckResultat from '@/mixins/checkresultat'
import mixinTooltip from '@/mixins/tooltip'
import { mapActions } from 'vuex'

export default {
  name: 'SimulationIlot',
  mixins: [mixinConfirmation, mixinCheckResultat, mixinTooltip],
  inject: ['$validator'],

  components: {
    Priorite
  },

  props: {
    idIlot: {
      type: String,
      required: true
    },
    idExploitation: {
      type: String,
      required: true
    },
    idSimulation: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      parcelles: this.$store.state.simulation.currentSimulation.parcelles
        .filter(p => p.id_ilot === this.idIlot)
        .map(p => {
          return {
            ...p
          }
        }),
      showPriority: false
    }
  },

  computed: {
    ilot () {
      return this.$store.getters.getIlotById(this.idIlot)
    },
    sols () {
      return this.$store.getters.getSolIlotById(this.idIlot)
    },

    cultures () {
      return this.$store.getters.getCultures
    },

    scenarios () {
      return this.$store.state.simulation.currentSimulation.scenarios
    }
  },

  methods: {
    ...mapActions(['createScenario', 'updateScenario', 'removeScenario', 'duplicateScenario']),
    ...mapActions('prompt', ['prompt']),
    ...mapActions('confirm', ['confirm']),
    ...mapActions('alerte', ['alerte']),

    getParcelle (typeSol, culture, scenario) {
      return this.parcelles.find(
        p =>
          p.id_ref_type_sol === typeSol &&
          p.id_culture === culture &&
          p.id_scenario === scenario
      )
    },

    getCellValueSurface (typeSol, culture, scenario) {
      let parcelle = this.getParcelle(typeSol, culture, scenario)
      return parcelle ? parseFloat(parcelle.surface) : 0
    },

    getCellValueDose (typeSol, culture, scenario) {
      let parcelle = this.getParcelle(typeSol, culture, scenario)
      if (!parcelle) {
        return null
      }
      let valeur = parseFloat(parcelle.dose)
      return isNaN(valeur) ? null : valeur
    },

    getOrderValue (typeSol, culture, scenario) {
      let parcelle = this.getParcelle(typeSol, culture, scenario)
      let order = parcelle ? parcelle.ordre : 0
      return order !== 0 ? order : null
    },

    getSommeSurface (typeSol, scenario) {
      return this.parcelles
        .filter(
          p => p.id_ref_type_sol === typeSol && p.id_scenario === scenario
        )
        .reduce((total, parcelle) => (total += parseFloat(parcelle.surface * 10) || 0), 0) / 10
    },

    updateCellValueSurface (typeSol, culture, scenario, newValue) {
      let parcelle = this.getParcelle(typeSol, culture, scenario)
      if (!parcelle) {
        this.parcelles.push({
          id_ilot: this.idIlot,
          id_ref_type_sol: typeSol,
          id_culture: culture,
          id_scenario: scenario,
          surface: newValue,
          dose: null
        })
      } else {
        parcelle.surface = newValue
      }
      this.$nextTick(() => {
        this.$validator.validateScopes()
      })
    },

    updateCellValueDose (typeSol, culture, scenario, newValue) {
      let parcelle = this.getParcelle(typeSol, culture, scenario)
      if (newValue < 0) {
        newValue = null
      }
      if (!parcelle) {
        this.parcelles.push({
          id_ilot: this.idIlot,
          id_ref_type_sol: typeSol,
          id_culture: culture,
          id_scenario: scenario,
          surface: 0,
          dose: newValue
        })
      } else {
        parcelle.dose = newValue
      }
      this.$nextTick(() => {
        this.$validator.validateScopes()
      })
    },

    saveData () {
      return this.$store.dispatch('saveParcelles', {
        idExploitation: this.idExploitation,
        idSimulation: this.idSimulation,
        idIlot: this.idIlot,
        parcelles: this.parcelles
      }).then(() => {
        this.clearflags()
      })
    },

    addScenario () {
      this.prompt({
        title: 'Ajout scénario',
        label: 'Nom du scénario',
        okText: 'Créer'
      }).then(resultat => {
        if (resultat !== false) {
          this.createScenario({
            idExploitation: this.idExploitation,
            idSimulation: this.idSimulation,
            nom: resultat
          })
        }
      })
    },

    save () {
      return this.$validator.validateScopes().then(result => {
        if (!result) {
          this.alerte({
            title: 'Erreur',
            message: 'Des erreurs sont présentes',
            okTest: 'Ok'
          })
          return Promise.reject(new Error('Des erreurs sont présentes'))
        } else {
          return this.confirmresult()
            .then(confirmation => {
              if (confirmation) {
                this.saveData()
              }
            })
        }
      })
    },

    checkBeforeSave (next) {
      if (!this.$store.state.auth.authenticated) {
        return next()
      }
      this.$validator.validateScopes().then(result => {
        let p = Promise.resolve(true)
        if (!result) {
          p = this.confirm({
            title: 'Données incorrectes',
            message: 'Des erreurs existent, êtes-vous sûr de quitter la page ?',
            okText: 'Continuer'
          })
        }
        p.then(r => {
          r && this.saveData().then(next)
        })
      })
    },

    doDuplicateScenario (idScenario, actualName) {
      this.prompt({
        title: 'Dupliquer',
        label: 'Libellé du nouveau scénario',
        okText: 'Dupliquer',
        text: 'copie de ' + actualName
      })
        .then((resultat) => {
          if (resultat !== false) {
            this.duplicateScenario({
              idExploitation: this.idExploitation,
              idSimulation: this.idSimulation,
              idScenario: idScenario,
              nom: resultat
            }).then(scenarioId => {
              this.$store.dispatch('loadSimulation', { idExploitation: this.idExploitation, idSimulation: this.idSimulation })
                .then(() => {
                  let newParcelle = this.parcelles.filter(p => p.id_scenario === idScenario)
                    .map(p => ({ ...p, id_scenario: scenarioId }))
                  this.parcelles = this.parcelles.concat(newParcelle)
                  this.$store.dispatch('success', 'Scénario dupliqué')
                })
                .catch(() => {
                  this.$store.dispatch('error', 'Une erreur est survenue lors du chargement des données.')
                })
            })
          }
        })
    },

    doRenameScenario (idScenario, actualName) {
      this.prompt({
        title: 'Renommer',
        label: 'Libellé du scénario',
        okText: 'Renommer',
        text: actualName
      })
        .then((resultat) => {
          if (resultat !== false) {
            this.updateScenario({
              idExploitation: this.idExploitation,
              idSimulation: this.idSimulation,
              idScenario: idScenario,
              nom: resultat
            })
              .then(() => this.$store.dispatch('success', 'Scénario modifié'))
          }
        })
    },

    doRemoveScenario (idScenario) {
      this.confirm({
        title: 'Suppression scénario',
        message: 'Êtes vous-sûr de vouloir supprimer ce scénario ?',
        okText: 'Supprimer'
      })
        .then(confirmation => {
          if (confirmation) {
            this.removeScenario({
              idExploitation: this.idExploitation,
              idSimulation: this.idSimulation,
              idScenario: idScenario
            })
              .then(() => {
                this.parcelles = this.parcelles.filter(p => p.id_scenario !== idScenario)
                this.$store.dispatch('success', 'Scénario supprimé')
              })
          }
        })
    },

    onValidatePriority (parcelles) {
      this.parcelles = parcelles
      this.save().then(() => {
        this.showPriority = false
      })
    },

    addClassIfNoData (refTypeSol, cultureId) {
      const isData = this.scenarios.some(el => this.getCellValueSurface(refTypeSol, cultureId, el.id_scenario) > 0)

      return isData ? '' : 'no-data'
    }
  }
}
</script>
